import axios from 'axios'
import { Toast } from 'vant'

let config = {
  timeout: 60 * 1000, // Timeout 设置
  withCredentials: false, // 是否检查跨域  Check cross-site Access-Control
}

const $axios = axios.create(config)


//请求拦截器
$axios.interceptors.request.use(
  config => {
    const { loading } = config
    if (loading) {
      Toast.loading({
        message: '拼命加载中',
        forbidClick: true,
        duration: 0
      });
    }
    return config
  },
  error => {
    Toast.clear()
    return Promise.reject(error)
  }
)

// 响应拦截器
$axios.interceptors.response.use(
  response => {
    if (response.config.method == 'get') {
      if (response.status == '200') {
        return Promise.resolve(response.data)
      } else {
        return Promise.reject(response)
      }
    } else {
      Toast.clear()
      return Promise.resolve(response.data)
    }
  },
  error => {
    Toast.clear()
    if (error.message === 'Network Error') {
      Toast.fail('Network connection error, please check your network');
    }
    return Promise.reject(error)
  }
)



export default $axios